import { AuthContextProvider } from '@ankr.com/auth';
import { QueryParamProvider } from 'use-query-params';
import { ReactNode } from 'react';

import { ReactRouter7Adapter } from 'modules/router/components/ReactRouter7Adapter';
import { APIGateways } from 'modules/auth/const';

import { useAuthDataSubscriber } from './hooks/useAuthDataSubscriber';

export interface IAuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: IAuthProviderProps) => {
  useAuthDataSubscriber();

  return (
    <QueryParamProvider adapter={ReactRouter7Adapter}>
      <AuthContextProvider Gateways={APIGateways}>
        {children}
      </AuthContextProvider>
    </QueryParamProvider>
  );
};
